/**
 * Shared filter configuration for list and board views
 * 
 * This ensures both views use the same filters and avoids code duplication.
 * Any changes to filters here will automatically apply to both list and board views.
 * 
 * This configuration can also be reused for other pages that need the same filtering functionality.
 */

export const ALL_AVAILABLE_FILTERS = [
  'providerName',
  'mappingName',
  'organisation',
  'nextDueDate',
  'user',
  'preparer',
  'reviewer',
  'client',
  'status',
  'dataLog.submissionDate',
  'submittedBy',
  'period',
];

export const DEFAULT_VISIBLE_FILTERS = [
  'organisation',
  'nextDueDate',
  'user',
  'status',
  'dataLog.submissionDate',
];

export const FILTER_SELECTION_PREFERENCE = 'submissions-visible-filters';

